export default{
    setUser(state,payload){
        state.token = payload.token;
        state.userId = payload.userId;
        state.profil = payload.profil;
        state.firstName = payload.firstName;
        state.lastName = payload.lastName;
        state.supId = payload.supId
    }
}